module.exports = __webpack_public_path__ + "img/下载.3f8bba0c.svg";